import { h } from "preact";
import { formatMoney } from "@helpers/currency";

function MiniCartFreeGift() {
  const giftProductId = window.themeVars?.free_gift.gift_product_id;
  const freeGiftThreshold = window.themeVars?.free_gift.threshold;

  if (!giftProductId) {
    return null;
  }

  return (
    <uwp-free-gift
      free-gift-product={giftProductId || ""}
      data-threshold={freeGiftThreshold || "0"}
      style="display: none;"
    >
      <div className="free-gift">
        {window.themeVars?.free_gift.title && (
          <h3 className="free-gift__title">
            {window.themeVars?.free_gift.title}
          </h3>
        )}

        {window.themeVars?.free_gift.title_threshold && (
          <h3
            className="
            free-gift__title-threshold
            heading-4
          "
          >
            {window.themeVars?.free_gift.title_threshold}
          </h3>
        )}

        {window.themeVars?.free_gift.text && (
          <p className="free-gift__text">{window.themeVars?.free_gift.text}</p>
        )}

        {giftProductId && (
          <div className="free-gift__product">
            <img
              className="free-gift__product-image"
              width="58"
              height="58"
              loading="lazy"
              src={window.themeVars?.free_gift.gift_product_img}
              alt={window.themeVars?.free_gift.gift_product_title}
            />

            <div className="free-gift__product-content">
              <h3 className="free-gift__product-title heading-4">
                {window.themeVars?.free_gift.gift_product_title}
              </h3>

              <p className="free-gift__product-variant">
                {window.themeVars?.free_gift.gift_product_variant}
              </p>

              <p className="free-gift__product-price">
                <strong>Free</strong>
                <span>
                  {formatMoney(window.themeVars?.free_gift.gift_product_price)}
                </span>
              </p>
            </div>

            <button
              className="free-gift__product-cta"
              data-add-to-cart
              dangerouslySetInnerHTML={{
                __html: window.themeVars.icons.addToCart,
              }}
            ></button>
          </div>
        )}
      </div>
    </uwp-free-gift>
  );
}

export default MiniCartFreeGift;
